(() => {
  const selector = '.svg-draw-on-scroll';
  const initializedAttribute = 'data-svg-draw-on-scroll-initialized';
 
  const prepareSvg = (svg) => {
    const paths = Array.from(svg.querySelectorAll('path'));
 
    paths.forEach((path) => {
      if (typeof path.getTotalLength !== 'function') {
        return;
      }
 
      path.style.setProperty('--svg-draw-path-length', Math.ceil(path.getTotalLength()));
    });
  };
 
  const initSvgDrawOnScroll = (root = document) => {
    const svgs = Array.from(root.querySelectorAll(selector)).filter(
      (svg) => svg.getAttribute(initializedAttribute) !== 'true'
    );
 
    if (!svgs.length) {
      return;
    }
 
    if (!('IntersectionObserver' in window)) {
      svgs.forEach((svg) => {
        prepareSvg(svg);
        svg.classList.add('is-drawn');
        svg.setAttribute(initializedAttribute, 'true');
      });
      return;
    }
 
    const svgObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }
 
        entry.target.classList.add('is-drawn');
        svgObserver.unobserve(entry.target);
      });
    }, { threshold: 0.35 });
 
    svgs.forEach((svg) => {
      prepareSvg(svg);
      svg.setAttribute(initializedAttribute, 'true');
      svgObserver.observe(svg);
    });
  };
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSvgDrawOnScroll(), { once: true });
  } else {
    initSvgDrawOnScroll();
  }
 
  document.addEventListener('shopify:section:load', (event) => {
    initSvgDrawOnScroll(event.target);
  });
})();